module.exports = __webpack_public_path__ + "static/img/shcygn5.e96a8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/shcygn5.png
// module id = 375
// module chunks = 0